import {Component, Input, OnInit} from '@angular/core';
import {Globals} from '../../../../globals';
import {StaticDataService} from '../../../../services/static-data.service';
import {DataPatientCaseWorkItemToothModel} from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import {
    DataPatientCaseWorkItemFormToothModel
} from '../../../../models/teeth/data-patient-case-work-item-form-tooth.model';
import {
    PatientCaseEndoFinalReportDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-data.model';
import {FinalReportService} from '../../../../services/final-report.service';
import {DataPatientCaseModel, FinalReportInfoDto} from '../../../../models/accountsReceivable/data-patient-case.model';
import {ToothService} from '../../../../services/tooth.service';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {DataPatientCaseWorkItemModel} from '../../../../models/accountsReceivable/data-patient-case-work-item.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {DoctorsService} from '../../../../services/doctors.service';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {
    PatientCaseEndoFinalReportRestorRecomdDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-restor-recomd-data.model';
import {ReportConfigurationModel} from '../../../../models/configuration/report-configuration.model';
import {
    PatientCaseEndoFinalReportReferrRepDataModel
} from '../../../../models/finalReport/patient-case-endo-final-report-referr-rep-data.model';
import {UiService} from '../../../../services/ui.service';
import {NotesService} from '../../../../services/notes.service';
import {TdoNoteQueryModel} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {FinalReportRecallEnum} from '../../../../models/enum/final-report-recall.enum';
import {
    TdoNoteAssociatedObject,
    TdoNoteSaveModel
} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {MessagingService} from '../../../../services/messaging.service';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {NoteTypeEnum} from '../../../../models/enum/note-type.enum';
import {NoteCategoryEnum} from '../../../../models/enum/note-category.enum';
import {PatientService} from '../../../patient/patient.service';
import {dataPatient} from '../../../ar/_models/ar.models';
import {CaseService} from '../../../../services/case.service';

import {CommMethodEnum} from '../../../../models/enum/comm-method.enum';
import {NoteDataModel} from '../../../../models/notes/note-data.model';
import {Constants} from '../../../../constants';
import {DoctorTypeEnum} from '../../../../models/enum/doctor-type.enum';
import {SchedulingService} from '../../../scheduling/scheduling.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DialogService } from 'src/app/services/dialog.service';
import { constant } from 'cypress/types/lodash';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { TreatmentPlanningService } from 'src/app/modules/treatment-planning/treatment-planning.service';
import { ToastrService } from 'ngx-toastr';
import {DoctorQueryOptionsModel} from '../../../../models/doctors/doctor-query-options.model';

@Component({
    selector: 'app-final-report',
    templateUrl: './final-report.component.html',
    styleUrls: ['./final-report.component.scss']
})
export class FinalReportComponent implements OnInit {
    @Input() currentCaseId: string;
    @Input() caseWorkItemFormsId: string;

    isLoading = true;
    noteModel = new TdoNoteSaveModel();
    noteFind = new TdoNoteQueryModel();

    patientCaseModel: FinalReportInfoDto;
    caseTooth: DataPatientCaseWorkItemToothModel;
    caseTeeth: DataPatientCaseWorkItemToothModel[];
    caseFormTeeth: DataPatientCaseWorkItemFormToothModel[];
    workItem: DataPatientCaseWorkItemModel;

    finalReportModel: PatientCaseEndoFinalReportDataModel;
    reports: ReportConfigurationModel[] = [];

    cfgTeeth: ToothConfigurationModel[];
    toothName: string = '';

    statusEnums: EnumValidValueItemModel[] = [];
    prognosisEnums: EnumValidValueItemModel[] = [];
    recallEnums: EnumValidValueItemModel[] = [];
    medicalSpecialtyEnums: EnumValidValueItemModel[] = [];
    caseTypeEnums: EnumValidValueItemModel[] = [];
    restorationMethodEnums: EnumValidValueItemModel[] = [];
    treatmentSessionsEnums: EnumValidValueItemModel[] = [];
    caseRatingEnums: EnumValidValueItemModel[] = [];


    doctors: DoctorDataModel[];
    gpDoctors: DoctorDataModel[];
    nonGpDoctors: DoctorDataModel[];
    providerDoctors: DoctorDataModel[];

    fromDoctor: DoctorDataModel;
    generalDentist: string = '';
    referringDentist: string = '';
    isUserInput: boolean = false;
    patientData: dataPatient;
    referralEmail: string = '';
    referralDoctorContactId: string = '';
    doctorName: string = '';
    SentToLabel: string = '';
    reportDeliveryMethodEmail = '00000537-1000-0000-0000-000000000001';
    finalReportRestorationMethod_None = '00000233-1000-0000-0000-000000000001';
    dataPatientCaseEndoFinalReport = 'dataPatientCaseEndoFinalReport';
    doctorDisplayPredicate: (data: DoctorDataModel) => string;

    restOtherModel: PatientCaseEndoFinalReportRestorRecomdDataModel;

    constructor(private staticDataService: StaticDataService,
                private finalReportService: FinalReportService,
                private patientService: PatientService,
                private toothService: ToothService,
                private doctorService: DoctorsService,
                private uiService: UiService,
                private notesService: NotesService,
                private caseService: CaseService,
                private messagingService: MessagingService,
                private globals: Globals,
                private schedulingService: SchedulingService,
                private snackBar: MatSnackBar,
                private dialogService: DialogService,
                private treatmentPlanningService: TreatmentPlanningService,
                private toastr: ToastrService) {
        this.patientData = new dataPatient();
        this.noteModel.dataNote = new NoteDataModel();
    }

    ngOnInit(): void {
        console.log('FinalReportComponent Init');
        this.doctorDisplayPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName;

        this.currentCaseId = this.globals.currentPatientCaseId;
        if (!this.staticDataService.isReady) {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupEnums();
                }
            });
        } else {
            this.setupEnums();
        }


    }

    async setupEnums() {
        console.log('FinalReportComponent setupEnums');

        this.statusEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportCaseStatus');
        this.prognosisEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportPrognosis');
        this.recallEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRecall');
        this.medicalSpecialtyEnums = this.staticDataService.getValidValueItemsByValidValueName('enumMedicalSpecialty');
        this.caseTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseType');
        this.restorationMethodEnums = this.staticDataService.getValidValueItemsByValidValueName('enumFinalReportRestorationMethod');
        this.treatmentSessionsEnums = this.staticDataService.getValidValueItemsByValidValueName('enumTreatmentSessions');
        this.caseRatingEnums = this.staticDataService.getValidValueItemsByValidValueName('enumCaseRating');

        this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe(async (teethRes) => {
            this.cfgTeeth = teethRes;

            const queryModel = new DoctorQueryOptionsModel();
            queryModel.isIncludeReferring = true;
            queryModel.isIncludeTdo = false;

            this.doctorService.getDoctors(queryModel).subscribe((docRes) => {
                //const gpSpecialty = this.medicalSpecialtyEnums.find(p => p.ItemName === 'enumMedicalSpecialty.FamilyDoc');
                const gpSpecialtyValidValueItemId: string= '00000005-1000-0000-0000-000000000003';

                this.doctors = docRes;
                this.providerDoctors = docRes.filter(p => p.enumDoctorTypeID === DoctorTypeEnum.PROVIDER);
                this.gpDoctors = docRes.filter(p => {
                    if (p.enumDoctorTypeID === DoctorTypeEnum.REFERRALTO || p.enumDoctorTypeID === DoctorTypeEnum.REFERRALBOTH ) {
                        const specEnum = p.dataDoctorSpecialties.find(q =>
                            q.enumMedicalSpecialtyID === gpSpecialtyValidValueItemId);
                        if (specEnum) {
                            return p;
                        }
                    }
                });
                this.nonGpDoctors = docRes.filter(p => {
                    if (p.enumDoctorTypeID === DoctorTypeEnum.REFERRALTO || p.enumDoctorTypeID === DoctorTypeEnum.REFERRALBOTH ) {
                        const specEnum = p.dataDoctorSpecialties.find(q => q.enumMedicalSpecialtyID !== gpSpecialtyValidValueItemId);
                        if (specEnum) {
                            return p;
                        }
                    }
                });
            });

            this.finalReportService.getCaseInfo(this.currentCaseId, this.caseWorkItemFormsId).subscribe((caseRes) => {
                this.patientCaseModel = caseRes;
                if (this.patientCaseModel) {
                    const cfgTooth = this.cfgTeeth.find(p => p.ToothId === this.patientCaseModel.CaseWorkItemToothId);
                    if (cfgTooth) {
                        this.toothName = cfgTooth.Name;
                    }
                }

                this.finalReportService.getFinalReport(this.caseWorkItemFormsId).subscribe(async (reportRes) => {
                    if (reportRes) {
                        const noteQueryModel = new TdoNoteQueryModel();
                        noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
                        noteQueryModel.objectId = reportRes.CaseFinalReportID;
                        noteQueryModel.patientId = this.globals.currentPatientId;
                        noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
                        noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
                        this.notesService.changeNoteQuery(noteQueryModel);

                        this.finalReportModel = reportRes;
                        await this.SetFinalReportNoteAsync(noteQueryModel);
                        this.restOtherModel = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_None);
                    } else {
                        this.finalReportModel = new PatientCaseEndoFinalReportDataModel();
                        this.finalReportModel.PatientCaseId = this.currentCaseId;
                        this.finalReportModel.caseWorkItemFormsId = this.caseWorkItemFormsId;
                        this.finalReportModel.caseWorkItemID = this.globals.currentPatientCaseWorkItemID;
                        this.isUserInput = true;
                        this.saveChanges();


                    }

                    this.getReferralDoctorInfo();
                    this.noteModel.patientId = this.noteFind.patientId = this.globals.currentPatientId;
                    this.noteModel.categoryEnumIds = [NoteCategoryEnum.FinalReport];
                    this.noteFind.categoryEnumId = NoteCategoryEnum.FinalReport;
                    this.noteModel.typeEnumIds = [NoteTypeEnum.Patient];
                    this.noteFind.typeEnumId = NoteTypeEnum.Patient;

                    this.patientService.getPatient(this.globals.currentPatientId).subscribe(res => {
                        this.patientData = res.ThePatient;
                    });

                    this.finalReportService.getReports().subscribe((reportsRes) => {
                        this.reports = reportsRes;
                        this.isLoading = false;
                    });
                });
            });
        });

    }

    async saveChanges() {
        if (this.isUserInput) {
            console.log('FinalReportComponent savechanges');
            if (this.finalReportModel) {
                if (this.finalReportModel.NoteID === null || this.finalReportModel.NoteID === Constants.emptyGuid) {
                    const noteQueryModel = new TdoNoteQueryModel();
                    noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
                    noteQueryModel.objectId = this.finalReportModel.CaseFinalReportID;
                    noteQueryModel.patientId = this.globals.currentPatientId;
                    noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
                    noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
                    this.notesService.changeNoteQuery(noteQueryModel);
                    await this.SetFinalReportNoteAsync(noteQueryModel)
                }
                this.executeSaving();
               
            }
        }
    }

    executeSaving(){
        this.finalReportService.saveFinalReport(this.finalReportModel).subscribe((res) => {
            this.finalReportModel = res;
            this.finalReportModel.Note = this.noteModel.dataNote.Note;
            this.isUserInput = false;

            const noteQueryModel = new TdoNoteQueryModel();
            noteQueryModel.parentObjectName = this.dataPatientCaseEndoFinalReport;
            noteQueryModel.objectId =   this.finalReportModel.CaseFinalReportID ; //   reportRes.CaseFinalReportID;
            noteQueryModel.patientId = this.globals.currentPatientId;
            noteQueryModel.typeEnumId = NoteTypeEnum.Patient;
            noteQueryModel.categoryEnumId = NoteCategoryEnum.FinalReport;
            this.notesService.changeNoteQuery(noteQueryModel);



        });

    }

    savePatientDNETA() {
        if (this.isUserInput) {
            console.log('FinalReportComponent save Patient DNETA');
            this.patientService.UpdatePatientDNETA(this.patientData).subscribe((res) => {
                this.patientData = res;
            });
        }
    }

    onCancelClick() {

    }

    onOkClick() {

    }

    getEnumValue(enums: EnumValidValueItemModel[], id: string) {
        if (enums && enums.length > 0 && id) {
            const enu = enums.find(p => p.ValidValueItemId === id);
            if (enu) {
                return enu;
            }
        }
    }

    getDoctor(doctors: DoctorDataModel[], id: string) {
        if (doctors && id) {
            const doctor = doctors.find(p => p.DoctorId === id);
            if (doctor) {
                return doctor;
            }
        }
    }

    isRestorationChecked(rec: EnumValidValueItemModel) {
        const resIds = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.map(p => p.enumFinalReportRestorationMethodID);
        return resIds.includes(rec.ValidValueItemId);
    }

    onRestorationChange(event: MatCheckboxChange, rec: EnumValidValueItemModel) {
        console.log('FinalReportComponent onRestorationChange');
        this.isUserInput = true;

        const rest = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === rec.ValidValueItemId);

        if (rest) {
            // remove
            const idx = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.findIndex(p => p.enumFinalReportRestorationMethodID === rec.ValidValueItemId);
            if (idx > -1) {
                this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.splice(idx, 1);
            }
        } else {
            // add
            const model = new PatientCaseEndoFinalReportRestorRecomdDataModel();
            model.enumFinalReportRestorationMethodID = rec.ValidValueItemId;
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.push(model);
        }

        this.saveChanges();
    }

    isRestContainsOther() {
        const resIds = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.map(p => p.enumFinalReportRestorationMethodID);
        return resIds.includes(this.finalReportRestorationMethod_None);
    }

    onRestOtherChange(event: MatCheckboxChange) {
        const model = new PatientCaseEndoFinalReportRestorRecomdDataModel();
        model.enumFinalReportRestorationMethodID = this.finalReportRestorationMethod_None;
        model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
        this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.push(model);
        this.restOtherModel = model;
    }

    onOtherInputFinished(event: any) {
        console.log('FinalReportComponent onOtherInputFinished');
        this.isUserInput = true;
        const model = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_None);
        if (model) {
            model.OtherInText = event;
        }

        if (this.restOtherModel) {
            this.restOtherModel.OtherInText = event;
            this.saveChanges();
        }
    }

    onClearRest() {
        this.isUserInput = true;
        // console.log('FinalReportComponent onClearRest');
        this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds = [];
        this.saveChanges();
    }

    onClearReferralReports() {
        console.log('FinalReportComponent onClearReferralReports');
        this.isUserInput = true;
        this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps = [];
        this.saveChanges();
    }

    getOther() {
        const model = this.finalReportModel.dataPatientCaseEndoFinalReportRestorRecomds.find(p => p.enumFinalReportRestorationMethodID === this.finalReportRestorationMethod_None);
        if (model) {
            return model;
        } else {
            return null;
        }
    }

    onReportsChange(event: MatCheckboxChange, report: ReportConfigurationModel) {
        console.log('FinalReportComponent onReportsChange');
        this.isUserInput = true;
        const idx = this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.findIndex(p => p.ReportID === report.ReportID);
        if (idx > -1) {
            this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.splice(idx, 1);
        } else {
            // Add
            const model = new PatientCaseEndoFinalReportReferrRepDataModel();
            model.CaseFinalReportID = this.finalReportModel.CaseFinalReportID;
            model.ReportID = report.ReportID;
            model.enumReportDeliveryMethodID = this.reportDeliveryMethodEmail;
            model.SentTo = this.referralDoctorContactId;
            this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.push(model);
            // const results = await this.landingPageService.getAppointmentsForDoctorByDateRange('DocID', tdoDateRange.toString()).toPromise();
        }
        this.saveChanges();
    }

    async getReferralDoctorInfo() {
    // get Referral Doctor Information
        try {
            const doctorinfo = await this.doctorService.getReferringDoctorByCaseId(this.globals.currentPatientCaseId).toPromise();
            if (doctorinfo != null)
            {
                const contact = doctorinfo.dataContact;
                this.doctorName = contact.FirstName + ' ' + contact.MidName + ' ' + contact.LastName;
                const email = doctorinfo.dataContact.dataContactComms.filter(y => y.enumCommMethodID === CommMethodEnum.Email)[0];
                this.referralEmail = (email !== undefined && email !== null) ? email.Address : '';
                this.referralDoctorContactId = doctorinfo.dataContact.ContactId;
                this.SentToLabel = this.referralEmail !== '' ? this.doctorName + '(' + this.referralEmail + ')' : this.doctorName + ' (No email for Doctor)';
                if (this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0) {
                    if (this.referralDoctorContactId !== this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps[0].SentTo) {
                        this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.map(x => x.SentTo = this.referralDoctorContactId);
                        this.isUserInput = true;
                        this.saveChanges();
                    }
                }

            }
            else
            { // if not referral doctor associated with the case, then ask user for Referral Doctor
                const referralDoctor = await this.patientService.getPatientReferringDoctor(this.globals.currentPatientId).toPromise();
                if (referralDoctor && referralDoctor.DoctorId) {
                    const contact = referralDoctor.dataContact;
                    this.doctorName = contact.FirstName + ' ' + contact.MidName + ' ' + contact.LastName;
                    const email = referralDoctor.dataContact.dataContactComms.filter(y => y.enumCommMethodID === CommMethodEnum.Email)[0];
                    this.referralEmail = (email !== undefined && email !== null) ? email.Address : '';

                    this.dialogService.openConfirmDialog(`There is not referral Doctor associated to this case. Do you want to assign ${this.doctorName} - ${this.referralEmail}, as the referring Doctor for case: ${this.toothName}?`, true, false).subscribe((res1) => {
                        if (res1) {
                            this.referralDoctorContactId = referralDoctor.dataContact.ContactId;
                            this.SentToLabel = this.referralEmail !== '' ? this.doctorName + '(' + this.referralEmail + ')' : this.doctorName + ' (No email for Doctor)';
                            if (this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0)
                            {
                                if (this.referralDoctorContactId !== this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps[0].SentTo) {
                                    this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.map(x => x.SentTo = this.referralDoctorContactId);
                                    this.isUserInput = true;
                                    this.saveChanges();
                                }
                            }

                        }
                        else {
                            this.onClearReferralReports();
                            this.finalReportModel.isReportNeede = false;
                            this.referralDoctorContactId = Constants.emptyGuid;
                            this.referralEmail = null;
                        }
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }





    isRefChecked(report: ReportConfigurationModel) {
        const rep = this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.find(p => p.ReportID === report.ReportID);
        return !!rep;
    }

    setUserInput(event: boolean) {
        this.isUserInput = event;
    }

    onCaseStatusChange(event: EnumValidValueItemModel) {
    // onCaseStatusChange(event: any) {
        if (this.isUserInput) {
            console.log('FinalReportComponent onCaseStatusChange');
            // finalReportModel.enumFinalReportCaseStatusID = $event.value.ValidValueItemId; saveChanges()
            this.finalReportModel.enumFinalReportCaseStatusID = event.ValidValueItemId;
            this.finalReportModel.CompletedDate = new Date(Date.now());
            this.saveChanges();
        }

    }

    getCompletedDate() {
        if (this.finalReportModel.CompletedDate) {
            return new Date(this.finalReportModel.CompletedDate).toLocaleString();
        } else {
            return '';
        }
    }

    onOpenLetters() {
        this.uiService.openLettersWindow();
    }

    FinalReportPrognosisSelected(event: any) {
        if (this.isUserInput) {
            console.log('FinalReportComponent onPrognosisChange');
            this.finalReportModel.enumFinalReportPrognosisID = event.ValidValueItemId;
            this.saveChanges();
        }
    }

    onRecallTimeChange(event: any) {
        if (this.isUserInput) {
            console.log('FinalReportComponent onRecalTimeChange');

            this.finalReportModel.enumFinalReportRecallID = event.ValidValueItemId;
            const recallDate = new Date();
            let daysMonthsToAdd = 0;
            let addDays = 1;  // 1 = day , 0 = month
            switch (event.ValidValueItemId) {
            case FinalReportRecallEnum.THREE_DAYS:
                daysMonthsToAdd = 3;
                break;
            case FinalReportRecallEnum.ONE_WEEK:
                daysMonthsToAdd = 7;
                break;
            case FinalReportRecallEnum.TWO_WEEKS:
                daysMonthsToAdd = 14;
                break;
            case FinalReportRecallEnum.THREE_WEEKS:
                daysMonthsToAdd = 21;
                break;
            case FinalReportRecallEnum.SIX_WEEKS:
                daysMonthsToAdd = 42;
                break;
            case FinalReportRecallEnum.ONE_MONTH:
                daysMonthsToAdd = 1;
                addDays = 0;
                break;
            case FinalReportRecallEnum.TWO_MONTHS:
                daysMonthsToAdd = 2;
                addDays = 0;
                break;
            case FinalReportRecallEnum.THREE_MONTHS:
                daysMonthsToAdd = 3;
                addDays = 0;
                break;
            case FinalReportRecallEnum.SIX_MONTHS:
                daysMonthsToAdd = 6;
                addDays = 0;
                break;
            case FinalReportRecallEnum.ONE_YEAR:
                daysMonthsToAdd = 365;
                break;
            case FinalReportRecallEnum.TWO_YEARS:
                daysMonthsToAdd = 365 * 2;
                break;
            case FinalReportRecallEnum.THREE_YEARS:
                daysMonthsToAdd = 365 * 3;
                break;
            case FinalReportRecallEnum.FOUR_YEARS:
                daysMonthsToAdd = 365 * 4;
                break;
            case FinalReportRecallEnum.FIVE_YEARS:
                daysMonthsToAdd = 365 * 5;
                break;
            case FinalReportRecallEnum.SIX_YEARS:
                daysMonthsToAdd = 365 * 6;
                break;
            case FinalReportRecallEnum.SEVEN_YEARS:
                daysMonthsToAdd = 365 * 7;
                break;
            case FinalReportRecallEnum.EIGHT_YEARS:
                daysMonthsToAdd = 365 * 8;
                break;
            case FinalReportRecallEnum.NINE_YEARS:
                daysMonthsToAdd = 365 * 9;
                break;
            case FinalReportRecallEnum.TEN_YEARS:
                daysMonthsToAdd = 365 * 10;
                break;
            case FinalReportRecallEnum.ELEVEN_YEARS:
                daysMonthsToAdd = 365 * 11;
                break;
            case FinalReportRecallEnum.TWELVE_YEARS:
                daysMonthsToAdd = 365 * 12;
                break;
            case FinalReportRecallEnum.THIRTEEN_YEARS:
                daysMonthsToAdd = 365 * 13;
                break;
            case FinalReportRecallEnum.FOURTEEN_YEARS:
                daysMonthsToAdd = 365 * 14;
                break;
            case FinalReportRecallEnum.FIFTEEN_YEARS:
                daysMonthsToAdd = 365 * 15;
                break;
            }

            if (addDays == 1){
                // add day
                recallDate.setDate(recallDate.getDate() + daysMonthsToAdd);
            }
            if (addDays == 0){
                // add month
                recallDate.setMonth(recallDate.getMonth() + daysMonthsToAdd);
            }

            console.log(recallDate );
            this.finalReportModel.RecallDate = recallDate;
            this.saveChanges();
        }
    }

    getDateFromModel(recallDate: string) {
        if (recallDate) {
            const d = new Date(recallDate);
            return d.toDateString();
        } else {
            return '';
        }
    }

    onNoteInputFinished(event: string) {
        if (this.finalReportModel.CaseFinalReportID === null || this.finalReportModel.CaseFinalReportID === undefined) {
            this.saveChanges();
            setTimeout(() => {
                this.onNoteInputFinished(event);
            }, 1000);
        } else {
            this.noteModel.text = event;
            this.noteModel.dataNote.Note = event;
            this.noteModel.dataNote.NoteId = this.finalReportModel.NoteID;
            this.finalReportModel.Note = event;

            const assoc = new TdoNoteAssociatedObject();
            assoc.parentObjectName = this.noteFind.parentObjectName = this.dataPatientCaseEndoFinalReport;
            assoc.objectId = this.noteFind.objectId = this.finalReportModel.CaseFinalReportID;
            this.noteModel.associatedObjects = [assoc];

            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, this.noteModel);
            if (this.finalReportModel.NoteID === null || this.finalReportModel.NoteID === undefined) {
                this.updateSetFinalReportNote(this.noteFind);
            }
        }
    }

    updateSetFinalReportNote(noteFind: TdoNoteQueryModel) {
        this.notesService.getNotes(noteFind).subscribe((res) => {
            if (res) {
                if (res.length > 0) {
                    this.finalReportModel.NoteID = res[0].NoteId;
                    this.noteModel.dataNote = res[0];
                    this.isUserInput = true;
                    this.saveChanges();
                } else {
                    setTimeout(() => {
                        this.updateSetFinalReportNote(noteFind);
                    }, 1000);
                }
            } else {
                setTimeout(() => {
                    this.updateSetFinalReportNote(noteFind);
                }, 1000);
            }
        });
    }

    SetFinalReportNoteAsync(noteFind: TdoNoteQueryModel): Promise<void> {
        return new Promise((resolve, reject) => {
            this.notesService.getNotes(noteFind).subscribe({
                next: (res) => {
                    if (res) {
                        if (res.length > 0) {
                            this.finalReportModel.NoteID = res[0].NoteId;
                            this.finalReportModel.Note = res[0].Note;
                            this.noteModel.dataNote = res[0];
                        } else {
                            this.finalReportModel.NoteID = Constants.emptyGuid;
                        }
                    }
                    resolve(); // Resolve the promise after processing
                },
            });
        });
    }


    getReportName(reportId: string) {
        return this.reports.find(x => x.ReportID === reportId).ReportName;
    }


    displayMessage(type, message) {
        if (type.toLowerCase() === 'error')
        {this.toastr.error(message, null, { timeOut: 7000 }); }
        else if (type.toLowerCase() === 'warning')
        {this.toastr.warning(message, null, { timeOut: 3000 }); }
        else
        {this.toastr.success(message, null, { timeOut: 3000 }); }
    }



    async sendFinalReport() {
        this.isLoading = true;
        const caseWorkItemEventDoc = await this.treatmentPlanningService.getSelectedDoctorByCaseWorkItemFormID(this.caseWorkItemFormsId).toPromise();
        if (!caseWorkItemEventDoc?.ProviderDoctorId) {
            this.displayMessage('Warning', 'No doctor was selected from the case view.');
            this.isLoading = false;
            return;
        }


        const enterpriseId = localStorage.getItem('TDOEnterpriseId');
        if ((this.referralEmail === null || this.referralEmail === '') && this.finalReportModel.dataPatientCaseEndoFinalReportReferrReps.length > 0) { // if not referral email, and user is trying to send reports. Create alert
            this.createMessage('Please provide an email for Referral Doctor', 'Error');
            this.isLoading = false;
            return;
        }
        this.finalReportModel.caseWorkItemID = this.globals.currentPatientCaseWorkItemID;
        this.finalReportService.sendFinalReport(parseInt(this.globals.LOCID), this.globals.currentPatientId, parseInt(enterpriseId), this.referralEmail, this.referralDoctorContactId,  this.finalReportModel).subscribe(() => {
            this.createMessage('Final Report Submitted', 'Success');
            this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH_SELECT_CASE, {parentCaseId: this.globals.currentPatientCaseId});
            this.isLoading = false;
        }, err => {
            this.createMessage('Error', `Error saving Final Report: ${err.error.Message}`);
            this.isLoading = false;
        });
    } 

    createMessage(message: string, type: string) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }





    finalReportPrognosisSelected(event) {
        console.log('finalReportPrognosisSelected', event);
        this.finalReportModel.enumFinalReportPrognosisID = event.ValidValueItemId;
        this.saveChanges();
    }

    referrToDoctorSelected(event) {
        console.log('referrToDoctorSelected', event);
        this.isUserInput = true;
        this.finalReportModel.RefereToDoctorID = event.value?.DoctorId;
        this.saveChanges();
    }

    referrToGPDoctorSelected(event) {
        console.log('referrToGPDoctorSelected', event);
        this.isUserInput = true;
        this.finalReportModel.RefereToGPDoctorID = event.value?.DoctorId;
        this.saveChanges();
    }


    reportNeededChecked(event) {
        console.log('reportNeededChecked', event);
        this.isUserInput = true;
        this.finalReportModel.isReportNeede = !event.checked;
        if (event.checked) {
            this.onClearReferralReports();
            return;
        }
        this.saveChanges();
    }

    log(val) {
        console.log(val);
    }

}
